'use client';

import type { PropsWithChildren } from 'react';
import type { TabsFilterValue } from '../../types/project/tabs';
import type { Collection } from '@/app/actions/collection';
import type { ApiError } from '@/app/hooks/useError';
import type { InteractionType } from '~/model/InteractionType';
import type { ProjectType } from '~/model/ProjectType';
import {
  createContext,

  useContext,
} from 'react';
import { useProjectInteractions } from '../../hooks/useProjectInteractions';

const ProjectInteractionsContext = createContext<ReturnType<typeof useProjectInteractions> | undefined>(undefined);

export const useProjectInteractionsContext = () => {
  const context = useContext(ProjectInteractionsContext);
  if (!context) {
    throw new Error(
      'useProjectInteractionsContext must be called within ProjectInteractionsProvider',
    );
  }
  return context;
};

export const ProjectInteractionsProvider = ({
  children,
  project: baseProject,
  collections: baseCollections,
  interaction: baseInteraction,
}: PropsWithChildren<{
  project: ProjectType;
  collections: Record<TabsFilterValue, Collection<InteractionType>>;
  interaction: InteractionType & ApiError;
}>) => {
  const value = useProjectInteractions({
    project: baseProject,
    collections: baseCollections,
    interaction: baseInteraction,
  });

  return (
    <ProjectInteractionsContext.Provider value={value}>
      {children}
    </ProjectInteractionsContext.Provider>
  );
};
